module.exports = __webpack_public_path__ + "assets/img/17.f00669de.png";